import React from "react";

const Privacy: React.FC = () => {
  return (
    <div className="container mx-auto p-4 max-w-[800px] text-white opacity-70">
      <h1 className="text-2xl font-bold mb-4 ">Privacy Policy</h1>
      <div id="PrivacyPolicy">
        <p>
          <b>Data Protection</b>
          <br />
          We would like to inform you about our privacy policy. Here you will
          find information about the collection and use of personal data when
          using our website. We observe the applicable data protection laws in
          Germany. You can access this statement at any time on our website.
          <br />
          <br />
          Please note that data transmission over the Internet (e.g.,
          communication by e-mail) may have security vulnerabilities and cannot
          be completely protected from access by third parties.
          <br />
          <br />
          The use of contact data from our imprint for commercial advertising is
          expressly not desired unless we have given our prior written consent
          or a business relationship already exists. The provider and all
          persons named on this website hereby object to any commercial use and
          disclosure of their data.
          <br />
          <br />
          <strong>Personal Data</strong>
          <br />
          You can visit our website and use our apps without providing personal
          information. Personal data, such as names, addresses, or e-mail
          addresses, are collected on a voluntary basis, if possible. These data
          will not be passed on to third parties without your express consent.
          If a contractual relationship between you and us is to be established,
          modified, or amended, or if you submit an inquiry to us, we will
          collect and use personal data from you to the extent necessary for
          these purposes (inventory data). We collect, process, and use personal
          data as far as necessary to enable you to use the website (usage
          data). All personal data is stored only as long as necessary for the
          stated purpose (processing your inquiry or handling a contract). Tax
          and commercial retention periods are taken into account. On the order
          of the competent authorities, we may provide information about these
          data (inventory data) to the extent necessary for purposes of law
          enforcement, security, fulfillment of the statutory duties of the
          constitutional protection authorities, or the military
          counter-intelligence service or for the enforcement of intellectual
          property rights.
          <br />
          <br />
        </p>

        <br />

        <p>
          <strong>Right to Information</strong>
          <br />
          You have the right to request information about your stored data free
          of charge and without delay. You have the right to revoke your consent
          to the use of your personal data at any time with future effect. For
          information, please contact the provider using the contact details in
          the imprint.
        </p>
        <br />
      </div>
    </div>
  );
};

export default Privacy;
